<template>
	<div class="survey">
		<div class="survey-container">
			<div class="d-flex justify-space-between mb-7">
				<div>
					<h2 class="mr-5">Enkät om resvanor</h2>
					<p>– tack för att du bidrar!</p>
				</div>
				<div>
          <img
            width="119"
            :src="$apiUrl + '/storage/CLQ4NvrdRsUlnUhiUZxpVHAqzwXbVqDvpL2uvjv8.jpg'"
            alt=""
          />
				</div>
			</div>

			<div v-if="stepIndex === 0">
				<p>I denna enkät får du svara på hur ditt vardagsresande ser ut idag och hur du önskar färdas framöver. Dina svar är värdefulla – oavsett om du färdas långt, kort, ofta eller sällan. Vi använder dem för att skapa ännu bättre förutsättningar för smart resande åt dig och oss alla.</p>
				<p>Det går snabbt att svara.</p>

				<h2 class="mt-10 mb-2">Hur brukar du färdas <span style="color: #0B24FB;">till och från JOBBET?</span></h2>
				<p class="mb-0"><em class="smaller-em">Fundera på vad som känns rimligt och fyll i det du tror.</em></p>


				<h4 class="mt-3 mb-3" :class="{surveyError: errors.includes('mainModeOfTransport')}">Vad anser du vara ditt huvudsakliga färdsätt?</h4>

				<ModeOfTransport :key="1" :value="mainModeOfTransport" @selected="selectModeOfTransport" />

				<div class="nudgd-btn inline survey-submit mt-5" @click="confirmFirstStep()" v-if=" ! firstStepConfirmed">Gå vidare</div>
				<div style="clear:both;"></div>

				<template v-if="firstStepConfirmed">

					<h4 class="mt-2 mb-3">Hur många dagar per vecka använder du följande färdsätt till/från jobbet, i genomsnitt?</h4>
					<p class="mb-2"><em class="smaller-em">(Runda av till närmaste heltal. Om du bara använder ett visst färdsätt 1 gång/4 veckor = 0,25, vilket avrundas till 0. Vänligen svara på alla.)</em></p>
					<div class="survey-frequency-chips walk">
						<h3 :class="{surveyError: errors.includes('frequencyWalk')}">🚶 Till fots</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip walking" :class="{active: frequencyWalk == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyWalk', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('frequencyBike')}">🚲 Cykel</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip bike" :class="{active: frequencyBike == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyBike', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('frequencyTransit')}">🚌 Kollektivt</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip transit" :class="{active: frequencyTransit == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyTransit', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('frequencyCar')}">🚗 Bil - själv/med hushållsmedlem</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip car" :class="{active: frequencyCar == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyCar', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('frequencyCarCoride')}">🚙 Bil - samåkning med annan</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip car" :class="{active: frequencyCarCoride == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyCarCoride', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>
					<div class="survey-frequency-chips">
						<h3 :class="{surveyError: errors.includes('frequencyMisc')}">Övrigt</h3>
						<div class="survey-frequency-chips-container">
							<div class="survey-frequency-chips-container-chip" :class="{active: frequencyMisc == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('frequencyMisc', number)">{{ number }}</div>
						</div>
						<div class="survey-frequency-chips-helpers right">
							<div>dagar per vecka</div>
						</div>
					</div>


					<h4 class="mt-2 mb-1">Hur många gånger per vecka färdas du från hemmet till jobbet och tillbaka, i genomsnitt?</h4>
					<p class="mb-2"><em class="smaller-em">(Tur och retur räknas alltså som en gång. Räkna även med de gånger då du färdas till någon annan plats på vägen till eller från jobbet.)</em></p>

					<div class="survey-thirds mt-3">
						<div class="survey-thirds-first" :class="{surveyError: errors.includes('numberOfTrips')}">Antal resor:</div>

						<div class="survey-thirds-middle">
							<vue-slider dotSize="20" :max="35" v-model="numberOfTrips"></vue-slider>
						</div>

						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="numberOfTrips"></v-text-field> st</div>
					</div>



					<h4 class="mt-6 mb-6">Hur långt har du i genomsnitt tagit dig till och från jobbet per vecka med följande färdsätt?</h4>
						<p class="mb-2"><em class="smaller-em">(Räkna med både vägen dit och vägen tillbaka, inklusive avståndet till andra platser du färdas till på vägen till eller från jobbet.)</em></p>
					<div class="survey-thirds walking mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyWalking')}">Till fots</div>
						<div class="survey-thirds-middle"><vue-slider :max="200" v-model="weeklyWalking"><template v-slot:dot><div class="custom-dot alt">🚶</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyWalking"></v-text-field> km</div>
					</div>

					<div class="survey-thirds bike mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyBike')}">Cykel</div>
						<div class="survey-thirds-middle"><vue-slider :max="200" v-model="weeklyBike"><template v-slot:dot><div class="custom-dot alt">🚲</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyBike"></v-text-field> km</div>
					</div>

					<div class="survey-thirds transit mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyTransit')}">Kollektivt</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="weeklyTransit"><template v-slot:dot><div class="custom-dot alt">🚌</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyTransit"></v-text-field> km</div>
					</div>

					<div class="survey-thirds car mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyCar')}">Bil - själv/med hushållsmedlem</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="weeklyCar"><template v-slot:dot><div class="custom-dot alt">🚗</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyCar"></v-text-field> km</div>
					</div>

					<div class="survey-thirds car carCoride mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyCarCoride')}">Bil - samåkning med annan</div>
						<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="weeklyCarCoride"><template v-slot:dot><div class="custom-dot alt">🚙</div></template></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyCarCoride"></v-text-field> km</div>
					</div>

					<div class="survey-thirds misc mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyMisc')}">
							<v-tooltip bottom>
						      <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">Övrigt <div class="tooltip-container"><span class="icon-info"></span></div></span></template>
						      <span>t.ex. elsparkcykel, skateboard etc."</span>
						    </v-tooltip>
						</div>
						<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="200" v-model="weeklyMisc"></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyMisc"></v-text-field> km</div>
					</div>

					<div class="survey-thirds-sum"><strong>SUMMA</strong> <span>{{ weeklySum }} km</span></div>

					<div class="survey-sum mt-6"><strong>Din genomsnittliga resa till/från arbetet är {{ computedWeeklyAverage }} km</strong> och du färdas <strong>{{ weeklySum }} km per vecka</strong>, vilket blir <strong>{{ yearlyDistance }} km utslaget på ett år</strong> (ifall du färdas likadant alla veckor om året).
						<br/>
						<br/>
						<em>Om reslängden per vecka verkar rimlig, vänligen gå vidare i enkäten. Om inte, justera i frågorna ovan.</em></div>


					<div v-if="weeklyCar">
						<h4 class="mt-5">Hur är dina bilresor fördelade utifrån drivmedel?</h4>
						<p class="mb-2"><em class="smaller-em">(Summan för de olika drivmedlen måste matcha med Bil - själv/med hushållsmedlem ovan ({{ weeklyCar }} km))</em></p>

						<div class="survey-thirds electricity mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyElectricity')}">El</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="weeklyElectricity"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyElectricity"></v-text-field> km</div>
						</div>

						<div class="survey-thirds hybrid mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyHybrid')}">Hybrid/gas</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="weeklyHybrid"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyHybrid"></v-text-field> km</div>
						</div>

						<div class="survey-thirds gas mt-3">
							<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('weeklyGas')}">Bensin/diesel<br/>/etanol</div>
							<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="weeklyGas"></vue-slider></div>
							<div class="survey-thirds-last"><v-text-field hide-details v-model.number="weeklyGas"></v-text-field> km</div>
						</div>
					</div>

					<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
					<div style="clear:both;"></div>
				</template>
			</div>

			<div v-if="stepIndex === 1">
				<h2 class="mt-10 mb-2">Hur brukar du färdas <span style="color: #0B24FB;">på FRITIDEN?</span></h2>
				<p class="mb-0"><em class="smaller-em">Tänk på en genomsnittlig vecka. Räkna med helger, men inte långresor på semester och dylikt.</em></p>


				<h4 class="mt-3 mb-3" :class="{surveyError: errors.includes('leisureMainModeOfTransport')}">Vad anser du vara ditt huvudsakliga färdsätt för dina fritidsresor?</h4>
				<ModeOfTransport :value="leisureMainModeOfTransport" :key="2" @selected="selectLeisureModeOfTransport" />

				<h4 class="mt-2 mb-3">Hur många gånger per vecka färdas du hemifrån till någon fritidsaktivitet och tillbaka, i genomsnitt?</h4>
				<p class="mb-2"><em class="smaller-em">(Runda av till närmaste heltal. Om du bara använder ett visst färdsätt 1 gång/4 veckor = 0,25, vilket avrundas till 0. Vänligen svara på alla.)</em></p>
				<div class="survey-frequency-chips walk">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyWalk')}">🚶 Till fots</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip walking" :class="{active: leisureFrequencyWalk == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyWalk', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyBike')}">🚲 Cykel</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: leisureFrequencyBike == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyBike', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyTransit')}">🚌 Kollektivt</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip transit" :class="{active: leisureFrequencyTransit == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyTransit', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyCar')}">🚗 Bil - själv/med hushållsmedlem</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: leisureFrequencyCar == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyCar', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyCarCoride')}">🚙 Bil - samåkning med annan</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: leisureFrequencyCarCoride == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyCarCoride', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>
				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('leisureFrequencyMisc')}">Övrigt</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip" :class="{active: leisureFrequencyMisc == number}" v-for="number in [0, 1, 2, 3, 4, 5, 6, 7]" :key="number" @click="selectFrequency('leisureFrequencyMisc', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers right">
						<div>dagar per vecka</div>
					</div>
				</div>

				<h4 class="mt-2 mb-1">Hur många gånger per vecka färdas du någonstans på fritiden, i genomsnitt?</h4>
				<p class="mb-2"><em class="smaller-em">(Tur och retur räknas alltså som en gång. Räkna INTE med när du färdas till någon annan plats på väg till eller från jobbet – det ingår på förra sidan.)</em></p>

				<div class="survey-thirds mt-3">
					<div class="survey-thirds-first" :class="{surveyError: errors.includes('leisureNumberOfTrips')}">Antal resor:</div>

					<div class="survey-thirds-middle">
						<vue-slider dotSize="20" :max="35" v-model="leisureNumberOfTrips"></vue-slider>
					</div>

					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureNumberOfTrips"></v-text-field> st</div>
				</div>


				<h4 class="mt-6 mb-6">Hur långt har du i genomsnitt färdats på fritiden per vecka med följande färdsätt?</h4>
				<p class="mb-2"><em class="smaller-em">(Räkna med både vägen till destinationen och vägen tillbaka.)</em></p>

				<div class="survey-thirds walking mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyWalking')}">Till fots</div>
					<div class="survey-thirds-middle"><vue-slider :max="200" v-model="leisureWeeklyWalking"><template v-slot:dot><div class="custom-dot alt">🚶</div></template></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyWalking"></v-text-field> km</div>
				</div>

				<div class="survey-thirds bike mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyBike')}">Cykel</div>
					<div class="survey-thirds-middle"><vue-slider :max="200" v-model="leisureWeeklyBike"><template v-slot:dot><div class="custom-dot alt">🚲</div></template></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyBike"></v-text-field> km</div>
				</div>

				<div class="survey-thirds transit mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyTransit')}">Kollektivt</div>
					<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="leisureWeeklyTransit"><template v-slot:dot><div class="custom-dot alt">🚌</div></template></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyTransit"></v-text-field> km</div>
				</div>

				<div class="survey-thirds car mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyCar')}">Bil - själv/med hushållsmedlem</div>
					<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="leisureWeeklyCar"><template v-slot:dot><div class="custom-dot alt">🚗</div></template></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyCar"></v-text-field> km</div>
				</div>

				<div class="survey-thirds car carCoride mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyCarCoride')}">Bil - samåkning med annan</div>
					<div class="survey-thirds-middle"><vue-slider :max="1000" v-model="leisureWeeklyCarCoride"><template v-slot:dot><div class="custom-dot alt">🚙</div></template></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyCarCoride"></v-text-field> km</div>
				</div>

				<div class="survey-thirds misc mt-3">
					<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyMisc')}">
						<v-tooltip bottom>
					      <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">Övrigt <div class="tooltip-container"><span class="icon-info"></span></div></span></template>
					      <span>t.ex. elsparkcykel, skateboard etc."</span>
					    </v-tooltip>
					</div>
					<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="200" v-model="leisureWeeklyMisc"></vue-slider></div>
					<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyMisc"></v-text-field> km</div>
				</div>

				<div class="survey-thirds-sum"><strong>SUMMA</strong> <span>{{ leisureWeeklySum }} km</span></div>

				<div class="survey-sum mt-6"><strong>Din genomsnittliga fritidsresa är {{ leisureComputedWeeklyAverage }} km</strong> och du färdas <strong>{{ leisureWeeklySum }} km per vecka</strong>, vilket blir <strong>{{ leisureYearlyDistance }} km utslaget på ett år</strong> (ifall du färdas likadant alla veckor om året).
					<br/>
					<br/>
					<em>Om reslängden per vecka verkar rimlig, vänligen gå vidare i enkäten. Om inte, justera i frågorna ovan.</em></div>


				<div v-if="leisureWeeklyCar">
					<h4 class="mt-5">Hur är dina bilresor fördelade utifrån drivmedel?</h4>
					<p class="mb-2"><em class="smaller-em">(Summan för de olika drivmedlen måste matcha med Bil - själv/med hushållsmedlem ovan ({{ leisureWeeklyCar }} km))</em></p>

					<div class="survey-thirds electricity mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyElectricity')}">El</div>
						<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="leisureWeeklyElectricity"></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyElectricity"></v-text-field> km</div>
					</div>

					<div class="survey-thirds hybrid mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyHybrid')}">Hybrid/gas</div>
						<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="leisureWeeklyHybrid"></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyHybrid"></v-text-field> km</div>
					</div>

					<div class="survey-thirds gas mt-3">
						<div class="survey-thirds-first-alt" :class="{surveyError: errors.includes('leisureWeeklyGas')}">Bensin/diesel<br/>/etanol</div>
						<div class="survey-thirds-middle"><vue-slider dotSize="20" :max="1000" v-model="leisureWeeklyGas"></vue-slider></div>
						<div class="survey-thirds-last"><v-text-field hide-details v-model.number="leisureWeeklyGas"></v-text-field> km</div>
					</div>
				</div>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<div v-if="stepIndex === 2">
				<h4 class="mt-0 mb-2" :class="{surveyError: errors.includes('currentLevelOfCar')}">Vilket av följande påståenden beskriver bäst hur du känner för din nuvarande bilanvändning i ditt vardagsresande och om du har några planer på att försöka minska några eller alla av dessa bilresor?</h4>
				<p class="mb-2"><em class="smaller-em">(Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.)</em></p>
				<v-radio-group class="mt-3 v-radio-group-small" v-model="currentLevelOfCar" row>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag är nöjd med detta och ser ingen anledning att minska min bilanvändning." value="Jag använder bilen för de flesta av mina resor. Jag är nöjd med detta och ser ingen anledning att minska min bilanvändning."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag vill minska min bilanvändning men det känns för närvarande inte möjligt." value="Jag använder bilen för de flesta av mina resor. Jag vill minska min bilanvändning men det känns för närvarande inte möjligt."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor. Jag funderar just nu på att ändra några eller alla av dessa resor till annat transportsätt men är osäker på hur eller när jag ska göra det." value="Jag använder bilen för de flesta av mina resor. Jag funderar just nu på att ändra några eller alla av dessa resor till annat transportsätt men är osäker på hur eller när jag ska göra det."></v-radio>
					<v-radio label="Jag använder bilen för de flesta av mina resor, men mitt mål är att minska min bilanvändning. Jag vet redan vilka resor jag kommer att ersätta och vilket transportsätt jag kommer att använda, men har ännu inte omsatt detta i praktiken." value="Jag använder bilen för de flesta av mina resor, men mitt mål är att minska min bilanvändning. Jag vet redan vilka resor jag kommer att ersätta och vilket transportsätt jag kommer att använda, men har ännu inte omsatt detta i praktiken."></v-radio>
					<v-radio label="Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning." value="Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning."></v-radio>
					<v-radio label="Eftersom jag är medveten om de många problem som är förknippade med bilanvändning, försöker jag redan använda andra transportsätt så mycket som möjligt. Jag kommer att behålla eller till och med minska min redan låga nivå av bilanvändning under de kommande månaderna." value="Eftersom jag är medveten om de många problem som är förknippade med bilanvändning, försöker jag redan använda andra transportsätt så mycket som möjligt. Jag kommer att behålla eller till och med minska min redan låga nivå av bilanvändning under de kommande månaderna."></v-radio>
				</v-radio-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('iHaveAccessTo')}">Jag har eller har tillgång till</h4>
				<v-chip-group active-class="primary--text" column multiple v-model="iHaveAccessTo">
				    <v-chip :disabled="currentLevelOfCar === 'Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning.'" value="Bil" outlined>Bil</v-chip>
					<v-chip :disabled="currentLevelOfCar === 'Eftersom jag inte äger/har tillgång till en bil är det för närvarande inte ett problem för mig att minska min bilanvändning.'" value="Bilpool" outlined>Bilpool</v-chip>
				    <v-chip value="Prisvärd parkering nära jobbet" outlined>Prisvärd parkering nära jobbet</v-chip>
						<v-chip value="Körkort" outlined>Körkort</v-chip>
				    <v-chip value="Bra kollektivtrafik" outlined>Bra kollektivtrafik</v-chip>
				    <v-chip value="Kollektivtrafikskort" outlined>Kollektivtrafikskort</v-chip>
						<v-chip value="Cykel" outlined>Cykel</v-chip>
				    <v-chip value="Cykelpool" outlined>Cykelpool</v-chip>
						<v-chip value="Inget av dessa" outlined>Inget av dessa</v-chip>
				</v-chip-group>


				<h4 class="mt-6 mb-2" :class="{surveyError: errors.includes('obstaclesToSustainability')}">Följande upplever jag som hinder för att färdas mer hållbart</h4>
				<p class="mb-2"><em class="smaller-em">(Ange de 2 som är störst hinder för dig. Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.)</em></p>
				<v-chip-group active-class="primary--text" column multiple v-model="obstaclesToSustainability" max="2">
				    <v-chip value="Tar för lång tid" outlined>Tar för lång tid</v-chip>
				    <v-chip value="Lämna familjemedlem på vägen" outlined>Lämna familjemedlem på vägen</v-chip>
				    <v-chip value="Tillgänglighet till bra kollektivtrafik" outlined>Tillgänglighet till bra kollektivtrafik</v-chip>
				    <v-chip value="Avstånd till arbetet" outlined>Avstånd till arbetet</v-chip>
				    <v-chip value="Obekvämt/för jobbigt" outlined>Obekvämt/för jobbigt</v-chip>
						<v-chip value="Säkerhet" outlined>Säkerhet</v-chip>
				    <v-chip value="Fysiskt hinder" outlined>Fysiskt hinder</v-chip>
						<v-chip value="Annat" outlined>Annat</v-chip>
				</v-chip-group>

				<h4 class="mt-5 mb-2">Kommentar</h4>
				<v-textarea class="mt-4" rows="4" hide-details solo v-model="obstaclesToSustainabilityComment" placeholder="Lägg gärna till något om vad som har gjort att du i vardagen färdas så som du för närvarande gör, och varför – vi vill höra vad du tycker!"></v-textarea>




				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<div v-if="stepIndex === 3">
				<h4 class="mb-3" :class="{surveyError: errors.includes('subjectiveSustainability')}">Jag anser att jag i dagsläget färdas hållbart i min vardag</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>
				<div class="survey-frequency-chips">
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: subjectiveSustainability == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('subjectiveSustainability', number)">
							{{ number }}
						</div>
					</div>

					<div class="survey-frequency-chips-helpers">
						<div>Nej,<br class="d-md-none"> inte alls</div>
						<div class="text-right">Ja,<br class="d-md-none"> fullt ut</div>
					</div>
				</div>



				<h4 class="mt-6 mb-1" :class="{surveyError: errors.includes('sustainabilityWish')}">Jag önskar att jag kunde färdas mer hållbart i min vardag</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>
				<div class="survey-frequency-chips" v-if=" ! alwaysWalkAndBike">
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: sustainabilityWish == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('sustainabilityWish', number)">
							{{ number }}
						</div>
					</div>

					<div class="survey-frequency-chips-helpers">
						<div>Nej,<br class="d-md-none"> inte alls</div>
						<div class="text-right">Ja,<br class="d-md-none"> väldigt mycket</div>
					</div>
				</div>
				<v-checkbox class="mb-5" hide-details v-model="alwaysWalkAndBike" value="Jag går/cyklar alltid och kan därför inte resa mer hållbart" label="Jag går/cyklar alltid och kan därför inte resa mer hållbart"></v-checkbox>


				<h4 class="mt-6 mb-2">Hur känner du inför att det närmaste året öka din användning av följande färdsätt i ditt vardagsresande?</h4>
				<p class="mb-2"><em class="smaller-em">Tänk både på att färdas till och från jobbet och på hur du färdas på fritiden.</em></p>

				<div class="survey-frequency-chips">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportWalk')}">🚶 Till fots</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip walking" :class="{active: wishedIncreaseModeOfTransportWalk == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportWalk', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportBike')}">🚲 Cykel</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip bike" :class="{active: wishedIncreaseModeOfTransportBike == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportBike', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportTransit')}">🚌 Kollektivtrafik</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip transit" :class="{active: wishedIncreaseModeOfTransportTransit == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportTransit', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCar')}">🚗 Bensin-/diesel-/etanolbil (själv eller med familjemedlem)</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCar == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCar', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCarSustainable')}">🚗 El-/biogas-/väte-/hybridbil (själv eller med familjemedlem)</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCarSustainable == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCarSustainable', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>
				<div class="survey-frequency-chips mt-7">
					<h3 :class="{surveyError: errors.includes('wishedIncreaseModeOfTransportCoride')}">🚙 Samåkning</h3>
					<div class="survey-frequency-chips-container">
						<div class="survey-frequency-chips-container-chip car" :class="{active: wishedIncreaseModeOfTransportCoride == number}" v-for="number in [1, 2, 3, 4, 5]" :key="number" @click="selectFrequency('wishedIncreaseModeOfTransportCoride', number)">{{ number }}</div>
					</div>
					<div class="survey-frequency-chips-helpers">
						<div>Definitivt<br class="d-md-none"> inte</div>
						<div class="text-right">Jättepositiv,<br class="d-md-none"> ska göra det</div>
					</div>
				</div>


				<h4 class="mt-6 mb-2" :class="{surveyError: errors.includes('mostImportantForMe')}">I mitt val av färdsätt är detta det som är viktigast för mig</h4>
				<v-chip-group active-class="primary--text" column multiple v-model="mostImportantForMe" max="2">
				    <v-chip value="Miljö" outlined>Miljö</v-chip>
				    <v-chip value="Hälsa" outlined>Hälsa</v-chip>
				    <v-chip value="Tid" outlined>Tid</v-chip>
				    <v-chip value="Kostnad" outlined>Kostnad</v-chip>
				    <v-chip value="Bekvämlighet" outlined>Bekvämlighet</v-chip>
						<v-chip value="Att resa så som mina kollegor/vänner gör" outlined>Att resa så som mina kollegor/vänner gör</v-chip>
						<v-chip value="Säkerhet" outlined>Säkerhet</v-chip>
				</v-chip-group>

				<h4 class="mt-5 mb-2">Kommentar</h4>
				<v-textarea class="mt-4" rows="4" hide-details solo v-model="mostImportantForMeComment" placeholder="Lägg gärna till något om vad som påverkar hur du tänker färdas i vardagen framöver, och varför – vi vill höra vad du tycker!"></v-textarea>



				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<div v-if="stepIndex === 4">
				<h4 class="mb-2" :class="{surveyError: errors.includes('gender')}">Kön</h4>
				<v-chip-group active-class="primary--text" column v-model="gender">
				    <v-chip value="Man" outlined>Man</v-chip>
				    <v-chip value="Kvinna" outlined>Kvinna</v-chip>
				    <v-chip value="Annat/Vill ej ange" outlined>Annat/Vill ej ange</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('birthYear')}">Födelseår (YYYY)</h4>
				<v-text-field dense v-model="birthYear" outlined hide-details></v-text-field>


				<h4 class="mb-2" :class="{surveyError: errors.includes('peopleInHousehold')}">Antal personer i hushållet</h4>
				<v-chip-group active-class="primary--text" column v-model="peopleInHousehold">
				    <v-chip value="1" outlined>1</v-chip>
				    <v-chip value="2" outlined>2</v-chip>
				    <v-chip value="3" outlined>3</v-chip>
				    <v-chip value="4" outlined>4</v-chip>
				    <v-chip value="5" outlined>5</v-chip>
				    <v-chip value="5+" outlined>5+</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('noOfChildren')}">Barn</h4>
				<v-chip-group active-class="primary--text" column v-model="noOfChildren">
					<v-chip value="Ja, upp till 12 år" outlined>Ja, upp till 12 år</v-chip>
					<v-chip value="Ja, tonåring(ar)" outlined>Ja, tonåring(ar)</v-chip>
				    <v-chip value="Ja, både upp till 12 år och tonåring(ar)" outlined>Ja, både upp till 12 år och tonåring(ar)</v-chip>
				    <v-chip value="Inga barn i hushållet" outlined>Inga barn i hushållet</v-chip>
				</v-chip-group>

				<h4 class="mb-2" :class="{surveyError: errors.includes('employment')}">Sysselsättning</h4>
				<v-chip-group active-class="primary--text" column v-model="employment">
				    <v-chip value="Arbetar" outlined>Arbetar</v-chip>
				    <v-chip value="Studerar" outlined>Studerar</v-chip>
						<v-chip value="Pensionär" outlined>Pensionär</v-chip>
				    <v-chip value="Annat" outlined>Annat</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('distanceEmployment')}">Distansarbete</h4>
				<p class="mb-2"><em class="smaller-em">I hur stor grad arbetar du på distans, t.ex. hemifrån?</em></p>
				<v-chip-group active-class="primary--text" column v-model="distanceEmployment">
				    <v-chip value="0%" outlined>0%</v-chip>
						<v-chip value="20%" outlined>20%</v-chip>
						<v-chip value="40%" outlined>40%</v-chip>
				    <v-chip value="60%" outlined>60%</v-chip>
				    <v-chip value="80%" outlined>80%</v-chip>
				    <v-chip value="100%" outlined>100%</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('educationAttainment')}">Utbildningsnivå</h4>
				<p class="mb-2"><em class="smaller-em">(Markera det högsta alternativet)</em></p>
				<v-chip-group active-class="primary--text" column v-model="educationAttainment">
				    <v-chip value="Grundskola" outlined>Grundskola</v-chip>
				    <v-chip value="Gymnasie" outlined>Gymnasie</v-chip>
				    <v-chip value="Högskola" outlined>Högskola</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('housingType')}">Bostadstyp</h4>
				<v-chip-group active-class="primary--text" column v-model="housingType">
				    <v-chip value="Hyresrätt" outlined>Hyresrätt</v-chip>
				    <v-chip value="Bostadsrätt" outlined>Bostadsrätt</v-chip>
				    <v-chip value="Villa" outlined>Villa</v-chip>
				    <v-chip value="Annat" outlined>Annat</v-chip>
				</v-chip-group>


				<h4 class="mb-2" :class="{surveyError: errors.includes('income')}">Ungefär hur stor är ditt hushålls totala inkomst före skatt en vanlig månad?</h4>
				<p class="mb-2"><em class="smaller-em">(Räkna med eventuella bidrag, t.ex. barnbidrag, bostadsbidrag, studiebidrag m.m.)</em></p>
				<v-chip-group active-class="primary--text" column v-model="income">
				    <v-chip value="Under 20 000" outlined>Under 20 000</v-chip>
				    <v-chip value="20 000 - 29 999" outlined>20 000 - 29 999</v-chip>
				    <v-chip value="30 000 - 39 999" outlined>30 000 - 39 999</v-chip>
				    <v-chip value="40 000 - 49 999" outlined>40 000 - 49 999</v-chip>
				    <v-chip value="50 000 - 59 999" outlined>50 000 - 59 999</v-chip>
				    <v-chip value="60 000 - 69 999" outlined>60 000 - 69 999</v-chip>
				    <v-chip value="70 000 - 79 999" outlined>70 000 - 79 999</v-chip>
				    <v-chip value="80 000 - 89 999" outlined>80 000 - 89 999</v-chip>
				    <v-chip value="90 000 - 99 999" outlined>90 000 - 99 999</v-chip>
				    <v-chip value="Över 100 000" outlined>Över 100 000</v-chip>
					  <v-chip value="Vill inte ange" outlined>Vill inte ange</v-chip>
				</v-chip-group>

				<div class="nudgd-btn inline survey-submit mt-10" @click="submitResponse()">Skicka in</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<v-progress-linear color="#00A19A" height="10" rounded class="mt-8" :value="(stepIndex + 1) / steps * 100"></v-progress-linear>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import ModeOfTransport from '@/components/ModeOfTransport.vue'

export default {
	components: {VueSlider, ModeOfTransport},

	mounted() {
		this.uuid = Math.random().toString(36).substr(2, 5)
		this.$store.state.surveyId = 8

		// For testing purposes
		if (this.$route.query.page) {
			this.stepIndex = parseInt(this.$route.query.page)
		}

		// Get end user
		axios.get(this.$apiUrl + '/api/end-user/' + this.$route.params.slug).then(res => {
			this.$store.state.endUser = res.data.endUser
			this.$store.state.translations = res.data.translations
		})
	},

	data() {
		return {
			steps: 5,
			numberOfTrips: 0,
			frequencyCar: null,
			frequencyCarCoride: null,
			frequencyBike: null,
			frequencyWalk: null,
			frequencyTransit: null,
			frequencyMisc: null,
			mainModeOfTransport: null,

			weeklyWalking: 0,
			weeklyBike: 0,
			weeklyTransit: 0,
			weeklyCar: 0,
			weeklyCarCoride: 0,
			weeklyMisc: 0,

			weeklyElectricity: 0,
			weeklyHybrid: 0,
			weeklyGas: 0,

			leisureMainModeOfTransport: null,
			leisureNumberOfTrips: 0,
			leisureFrequencyWalk: null,
			leisureFrequencyBike: null,
			leisureFrequencyTransit: null,
			leisureFrequencyCar: null,
			leisureFrequencyCarCoride: null,
			leisureFrequencyMisc: null,

			leisureWeeklyWalking: 0,
			leisureWeeklyBike: 0,
			leisureWeeklyTransit: 0,
			leisureWeeklyCar: 0,
			leisureWeeklyCarCoride: 0,
			leisureWeeklyMisc: 0,

			leisureWeeklyElectricity: 0,
			leisureWeeklyHybrid: 0,
			leisureWeeklyGas: 0,

			iHaveAccessTo: [],
			obstaclesToSustainability: [],
			currentLevelOfCar: null,

			subjectiveSustainability: null,
			sustainabilityWish: null,
			mostImportantForMe: [],
			alwaysWalkAndBike: null,

			obstaclesToSustainabilityComment: null,
			mostImportantForMeComment: null,

			income: null,
			housingType: null,
			educationAttainment: null,
			distanceEmployment: null,
			employment: null,
			noOfChildren: null,
			peopleInHousehold: null,
			birthYear: null,
			gender: null,

			wishedIncreaseModeOfTransportWalk: null,
			wishedIncreaseModeOfTransportBike: null,
			wishedIncreaseModeOfTransportTransit: null,
			wishedIncreaseModeOfTransportCar: null,
			wishedIncreaseModeOfTransportCarSustainable: null,
			wishedIncreaseModeOfTransportCoride: null,

			firstStepConfirmed: false,
			errors: [],
			engaged: [],
			stepIndex: 0,

			// Each array represents the required fields of a step
			required: [
				[
					'numberOfTrips', 'mainModeOfTransport', 'frequencyCar', 'frequencyCarCoride',
					'frequencyBike', 'frequencyWalk', 'frequencyTransit', 'frequencyMisc',
				],
				[
					'leisureNumberOfTrips', 'leisureMainModeOfTransport', 'leisureFrequencyCar', 'leisureFrequencyCarCoride',
					'leisureFrequencyBike', 'leisureFrequencyWalk', 'leisureFrequencyTransit', 'leisureFrequencyMisc',
				],
				['iHaveAccessTo', 'obstaclesToSustainability', 'currentLevelOfCar'],
				[
					'subjectiveSustainability', 'sustainabilityWish', 'mostImportantForMe',
					'wishedIncreaseModeOfTransportWalk', 'wishedIncreaseModeOfTransportBike',
					'wishedIncreaseModeOfTransportTransit', 'wishedIncreaseModeOfTransportCar',
					'wishedIncreaseModeOfTransportCarSustainable', 'wishedIncreaseModeOfTransportCoride'
				],
				['income', 'housingType', 'educationAttainment', 'distanceEmployment', 'employment',
				'noOfChildren', 'peopleInHousehold', 'birthYear', 'gender']
			],
		}
	},

	watch: {
		income(val) { this.engaged.push('income') },
		housingType(val) { this.engaged.push('housingType') },
		educationAttainment(val) { this.engaged.push('educationAttainment') },
		distanceEmployment(val) { this.engaged.push('distanceEmployment') },
		employment(val) { this.engaged.push('employment') },
		noOfChildren(val) { this.engaged.push('noOfChildren') },
		peopleInHousehold(val) { this.engaged.push('peopleInHousehold') },
		birthYear(val) { this.engaged.push('birthYear') },
		gender(val) { this.engaged.push('gender') },

		subjectiveSustainability(val) { this.engaged.push('subjectiveSustainability') },
		sustainabilityWish(val) { this.engaged.push('sustainabilityWish') },
		mostImportantForMe(val) { this.engaged.push('mostImportantForMe') },
		wishedIncreaseModeOfTransportWalk(val) { this.engaged.push('wishedIncreaseModeOfTransportWalk') },
		wishedIncreaseModeOfTransportBike(val) { this.engaged.push('wishedIncreaseModeOfTransportBike') },
		wishedIncreaseModeOfTransportTransit(val) { this.engaged.push('wishedIncreaseModeOfTransportTransit') },
		wishedIncreaseModeOfTransportCar(val) { this.engaged.push('wishedIncreaseModeOfTransportCar') },
		wishedIncreaseModeOfTransportCarSustainable(val) { this.engaged.push('wishedIncreaseModeOfTransportCarSustainable') },
		wishedIncreaseModeOfTransportCoride(val) { this.engaged.push('wishedIncreaseModeOfTransportCoride') },

		iHaveAccessTo(val) { this.engaged.push('iHaveAccessTo') },
		obstaclesToSustainability(val) { this.engaged.push('obstaclesToSustainability') },
		currentLevelOfCar(val) { this.engaged.push('currentLevelOfCar') },

		leisureNumberOfTrips(val) { this.engaged.push('leisureNumberOfTrips') },
		leisureMainModeOfTransport(val) { this.engaged.push('leisureMainModeOfTransport') },
		leisureFrequencyCar(val) { this.engaged.push('leisureFrequencyCar') },
		leisureFrequencyCarCoride(val) { this.engaged.push('leisureFrequencyCarCoride') },
		leisureFrequencyBike(val) { this.engaged.push('leisureFrequencyBike') },
		leisureFrequencyWalk(val) { this.engaged.push('leisureFrequencyWalk') },
		leisureFrequencyTransit(val) { this.engaged.push('leisureFrequencyTransit') },
		leisureFrequencyMisc(val) { this.engaged.push('leisureFrequencyMisc') },

		numberOfTrips(val) { this.engaged.push('numberOfTrips') },
		mainModeOfTransport(val) { this.engaged.push('mainModeOfTransport') },
		frequencyCar(val) { this.engaged.push('frequencyCar') },
		frequencyCarCoride(val) { this.engaged.push('frequencyCarCoride') },
		frequencyBike(val) { this.engaged.push('frequencyBike') },
		frequencyWalk(val) { this.engaged.push('frequencyWalk') },
		frequencyTransit(val) { this.engaged.push('frequencyTransit') },
		frequencyMisc(val) { this.engaged.push('frequencyMisc') },

		weeklyCar(val) { this.engaged.push('weeklyCar') },
		weeklyWalking(val) { this.engaged.push('weeklyWalking') },
		weeklyBike(val) { this.engaged.push('weeklyBike') },
		weeklyTransit(val) { this.engaged.push('weeklyTransit') },
		weeklyMisc(val) { this.engaged.push('weeklyMisc') },
		weeklyCarCoride(val) { this.engaged.push('weeklyCarCoride') },
		weeklyElectricity(val) { this.engaged.push('weeklyElectricity') },
		weeklyGas(val) { this.engaged.push('weeklyGas') },
		weeklyHybrid(val) { this.engaged.push('weeklyHybrid') },

		leisureWeeklyCar(val) { this.engaged.push('leisureWeeklyCar') },
		leisureWeeklyWalking(val) { this.engaged.push('leisureWeeklyWalking') },
		leisureWeeklyBike(val) { this.engaged.push('leisureWeeklyBike') },
		leisureWeeklyTransit(val) { this.engaged.push('leisureWeeklyTransit') },
		leisureWeeklyMisc(val) { this.engaged.push('leisureWeeklyMisc') },
		leisureWeeklyCarCoride(val) { this.engaged.push('leisureWeeklyCarCoride') },
		leisureWeeklyElectricity(val) { this.engaged.push('leisureWeeklyCarCoride') },
		leisureWeeklyGas(val) { this.engaged.push('leisureWeeklyCarCoride') },
		leisureWeeklyHybrid(val) { this.engaged.push('leisureWeeklyCarCoride') },

		alwaysWalkAndBike(val) {
			if (val) {
				this.sustainabilityWish = null
			}
		}
	},

	methods: {
		selectFrequency(property, value) {
			this[property] = value
		},

		selectModeOfTransport(mode) {
			this.mainModeOfTransport = mode
		},

		selectLeisureModeOfTransport(mode) {
			this.leisureMainModeOfTransport = mode
		},

		confirmFirstStep() {
			if ( ! this.mainModeOfTransport) {
				alert('Var god och välj ditt huvudsakliga färdsätt')
				return
			}

			this.firstStepConfirmed = true
		},

		nextStep() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			window.scrollTo(0, 0)

			this.stepIndex++
			this.saveState()
		},

		validate() {
			let required = this.required[this.stepIndex]

			// Determine which fields are engaged with (i.e. filled)
			// let engaged = []
			// for (const property in this.$data) {
			// 	if (this.$data[property] instanceof Array) {
			// 		if (this.$data[property].length > 0) {
			// 			engaged.push(property)
			// 		}
			// 	} else {
			// 		if (this.$data[property] !== null) {
			// 			engaged.push(property)
			// 		}
			// 	}
			// }

			if (this.stepIndex === 0) {
				if (parseInt(this.frequencyCar) > 0) { required.push('weeklyCar') }
				if (parseInt(this.frequencyCarCoride) > 0) { required.push('weeklyCarCoride') }
				if (parseInt(this.frequencyWalk) > 0) { required.push('weeklyWalking') }
				if (parseInt(this.frequencyBike) > 0) { required.push('weeklyBike') }
				if (parseInt(this.frequencyTransit) > 0) { required.push('weeklyTransit') }
				if (parseInt(this.frequencyMisc) > 0) { required.push('weeklyMisc') }
			}

			if (this.stepIndex === 1) {
				if (parseInt(this.leisureFrequencyCar) > 0) { required.push('leisureWeeklyCar') }
				if (parseInt(this.leisureFrequencyCarCoride) > 0) { required.push('leisureWeeklyCarCoride') }
				if (parseInt(this.leisureFrequencyWalk) > 0) { required.push('leisureWeeklyWalking') }
				if (parseInt(this.leisureFrequencyBike) > 0) { required.push('leisureWeeklyBike') }
				if (parseInt(this.leisureFrequencyTransit) > 0) { required.push('leisureWeeklyTransit') }
				if (parseInt(this.leisureFrequencyMisc) > 0) { required.push('leisureWeeklyMisc') }
			}

			if (this.stepIndex === 3) {
				if (this.alwaysWalkAndBike) {
					required = required.filter(v => ! v.includes('sustainabilityWish'))
				}
			}

			this.errors = required.filter(key => {
				return ! this.engaged.includes(key) || (this.$data[key] instanceof Array && this.$data[key].length === 0)
			})

			if (this.stepIndex === 0) {
				// If weeklyCar > 0, then the drivmedel should add up
				if (this.weeklyCar > 0 && (parseInt(this.weeklyElectricity) + parseInt(this.weeklyGas) + parseInt(this.weeklyHybrid) != this.weeklyCar)) {
					alert('Summan av drivmedel måste bli ' + this.weeklyCar)
					this.errors.push('weeklyElectricity')
					this.errors.push('weeklyGas')
					this.errors.push('weeklyHybrid')
				}
			}

			if (this.stepIndex === 1) {
				// If weeklyCar > 0, then the drivmedel should add up
				if (this.leisureWeeklyCar > 0 && (parseInt(this.leisureWeeklyElectricity) + parseInt(this.leisureWeeklyGas) + parseInt(this.leisureWeeklyHybrid) != this.leisureWeeklyCar)) {
					alert('Summan av drivmedel måste bli ' + this.leisureWeeklyCar)
					this.errors.push('leisureWeeklyElectricity')
					this.errors.push('leisureWeeklyGas')
					this.errors.push('leisureWeeklyHybrid')
				}
			}

			if (this.stepIndex === 4) {
				if (parseInt(this.birthYear) < 1900 || parseInt(this.birthYear) > 2022) {
					this.errors.push('birthYear')
				}
			}

			return this.errors.length === 0
		},

		prevStep() {
			window.scrollTo(0, 0)
			this.stepIndex--
		},

		saveState() {
			axios.post(this.$apiUrl + '/api/survey/8', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex
			})
		},

		submitResponse() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			axios.post(this.$apiUrl + '/api/survey/8', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex + 1,
				complete: true
			}).then(res => {
				this.$router.push({name: 'SurveyBPIThanks', params: {slug: this.$route.params.slug}})
            })
		}
	},

	computed: {
		weeklySum() {
			return parseInt(this.weeklyWalking) + parseInt(this.weeklyBike) + parseInt(this.weeklyTransit) + parseInt(this.weeklyCar) + parseInt(this.weeklyMisc)
		},

		computedWeeklyAverage() {
			if (this.numberOfTrips == 0) {
				return 0
			}

			return (this.weeklySum / this.numberOfTrips).toFixed(0).replace('.', ',')
		},

		yearlyDistance() {
			return this.weeklySum * 52
		},

		leisureWeeklySum() {
			return parseInt(this.leisureWeeklyWalking) + parseInt(this.leisureWeeklyBike) + parseInt(this.leisureWeeklyTransit) + parseInt(this.leisureWeeklyCar) + parseInt(this.leisureWeeklyMisc)
		},

		leisureComputedWeeklyAverage() {
			return (this.leisureWeeklySum / this.leisureNumberOfTrips).toFixed(0).replace('.', ',')
		},

		leisureYearlyDistance() {
			return this.leisureWeeklySum * 52
		},
	}
}
</script>
